import {RouterView} from 'vue-router'

// const HelpStandardOfPreSalePreparation =
export const HelpRoutes = [
  {
    path: '/help',
    component: RouterView,
    children: [
      // help/standard-of-pre-sale-preparation
      // - 2023.06.12
      // - 售前整备标准
      {
        path: 'standard-of-pre-sale-preparation',
        name: 'HelpStandardOfPreSalePreparation',
        component: () => import('@pages/help-standard-of-pre-sale-preparation'),
        meta: {
          title: '售前整备标准',
        },
      },

      // help/agreement
      // - 2023.06.12
      // - 自营车购买须知
      // - Merge from standard alone file, available routes:
      //   - new: help/agreement
      //   - old(alias): /agreement
      {
        path: 'agreement',
        alias: ['/agreement'],
        name: 'ZycAgreement',
        component: () => import('@pages/help-zyc-agreement'),
        meta: {
          title: '自营车购买须知',
        },
      },

      // help/coupon-guide
      // - 2023.06.12
      // - “感恩券”获取方式 & 使用规则
      // - Merge from standard alone route file, available routes:
      //   - new: /help/coupon-guide
      //   - old(alias): /coupon/guide
      {
        path: 'coupon-guide',
        alias: ['/coupon/guide'],
        name: 'CouponGuide',
        component: () => import('@pages/help-coupon-guide/index'),
        meta: {},
      },

      // help/coupon-landing
      // - 2023.06.12
      // - 感恩券领取方式
      // - Merge from standard alone route file, available routes
      //   - new: /help/coupon-sms-landing
      //   - old(alias): /coupon/landing
      {
        path: 'coupon-landing',
        alias: ['/coupon/landing'],
        name: 'CouponSmsLanding',
        component: () => import('@pages/help-coupon-sms-landing/index'),
        meta: {},
      },

      // help/delivery-notice/:id
      // - 2023.06.12
      // - 物流发运通知
      // - Merge from standard alone route file, available routes
      //   - new: /help/delivery-notice/:id
      //   - old(alias): /notice/delivery/:id
      // - Example: /help/delivery-notice/M2hucUNUOW9VVFEvNmhXWnUrZ3cvUT09
      {
        path: 'delivery-notice/:id',
        alias: ['/notice/delivery/:id'],
        name: 'DeliveryNotice',
        component:  () => import('@pages/help-delivery-notice/index'),
        meta: {},
      },

      // help/price-negotiable
      // - 2023.06.12
      // - 可议价 vs 一口价
      // - Merge from standard alone route file, available routes
      //   - new: /help/price-negotiable
      //   - old(alias): /vote/price/negotiable
      {
        path: 'price-negotiable',
        alias: ['/vote/price/negotiable'],
        name: 'PriceNegotiable',
        component: () => import('@pages/help-negotiable-price-vote/'),
      },

      // help/examine-notice/:id
      // - 2023.08.10
      // - 淘车-二鉴报告
      // - Example
      //   - Production https://zyc.nuonuo.com.cn/notice/examine/L2RHMW5xdGlnRFk9
      //   - Development https://localhost:3000/notice/examine/NnRZekt3SGk0dk09
      {
        path: 'examine-notice/:id',
        alias: ['/notice/examine/:id'],
        component: () => import('@pages/help-examine-notice/index'),
      },

      // help/release-release-note-weapp
      // - 2024.06.13
      // - 微信小程序更新日志
      {
        path: 'release-note-weapp',
        name: 'ReleaseNoteWeapp',
        component: () => import('@pages/help-release-note-weapp'),
        meta: {
          title: '更新日志',
        },
      },

      // help/random-consultant
      // - 2024.09.26
      // - 随机顾问
      {
        path: 'random-consultant',
        name: 'HelpRandomConsultant',
        component: () => import('@pages/help-random-consultant'),
        meta: {
          title: '购车咨询',
        },
      },

      // help/hunt-agreement
      // - 2025.01.20
      // - 淘车须知
      {
        path: 'hunt-agreement',
        name: 'HelpHuntAgreement',
        component: () => import('@pages/help-hunt-agreement'),
        meta: {
          title: '淘车须知',
        },
      },
    ],
  },
]
